export default __webpack_public_path__ + "static/media/pdf.3f864b19.svg";